<div class="wrapper">
  @if (data.content) {
    <ng-container [ngTemplateOutlet]="data.content"></ng-container>
  } @else {
    <div class="tw-flex tw-flex-col tw-gap-4">
      @if (data.title) {
        <span
          class="title"
          [class]="titleClasses.join(' ')"
        >
          {{ data.title | translate }}
        </span>
      }

      @if (data.message) {
        <span
          class="message"
          [class]="messageClasses.join(' ')"
        >
          {{ data.message | translate }}
        </span>
      }
    </div>
  }
  <div class="tw-flex tw-w-full tw-flex-col tw-gap-4 ph:tw-flex-row">
    @if (data.cancelText) {
      <app-ui-button
        [ngClass]="cancelClasses"
        (buttonClick)="cancel()"
      >
        {{ data.cancelText | translate }}
      </app-ui-button>
    }
    <app-ui-button
      [ngClass]="confirmClasses"
      (buttonClick)="confirm()"
    >
      {{ data.confirmText | translate }}
    </app-ui-button>
  </div>
</div>
<button
  class="close-btn"
  (click)="cancel()"
>
  <mat-icon
    class="close-icon"
    svgIcon="close"
  ></mat-icon>
</button>
